<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <template style="display: block">
            <div class="pop_tit">
                <p>물품</p>
            </div>

            <div class="content_wrap">
                <ul>
                    <li class="checkbox_wrap">
                        <span>공용</span>
                        <label>
                            <input type="checkbox" v-model="state.isShare" />
                            <em></em>
                        </label>
                    </li>

                    <li>
                        <span>물품명</span>
                        <input type="text" placeholder="물품명을 입력해주세요." v-model="state.name" />
                    </li>

                    <li class="file_wrap">
                        <span>물품사진</span>
                        <div class="area_file">
                            <label for="thuarea_filembnail_file">
                                <input
                                    id="thuarea_filembnail_file"
                                    type="file"
                                    placeholder=""
                                    accept="image/*"
                                    @change="handleFiles"
                                    v-show="false"
                                />

                                <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하여 첨부해주세요</div>
                                <span class="file_upload_btn">파일첨부</span>
                                <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                            </label>

                            <div class="file_list with_btn" v-if="state.fileUrl">
                                <div class="file_img">
                                    <img style="max-width: 100%; max-height: 250px" :src="state.fileUrl" alt="" />
                                </div>
                            </div>
                        </div>
                    </li>

                    <li>
                        <span>부서</span>
                        <div class="select-wrap">
                            <select v-model="state.dept">
                                <option value="0">선택해주세요.</option>
                                <option v-for="item in deptList" :value="item.key" v-text="item.name"></option>
                            </select>
                        </div>
                    </li>
                </ul>

                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">닫기</button>
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, watch, CommonUtils } from "@/BaseComponent";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        emits: ["close", "callback"],
        components: {},
        setup(props: any, { emit }: any) {
            const state = reactive({
                data: {} as any,

                idx: 0 as number,
                name: "" as string,
                isShare: false as boolean,
                file: {} as File | null,
                fileUrl: "" as string,
                dept: 0 as number,
            });

            const deptList = [
                { key: "1", name: "상담팀" },
                { key: "3", name: "현장팀" },
                { key: "6", name: "감시팀" },
            ];

            onMounted(() => {
                state.data = props.data;

                if (props.data) {
                    state.name = props.data.name;
                    state.isShare = props.data.isShare === 1 ? true : false;
                    state.dept = props.data.teIdx;
                    state.idx = props.data.idx;
                    state.fileUrl = props.data.file;
                }

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.data = props.data;

                if (props.data.name) {
                    state.name = props.data.name;
                    state.isShare = props.data.isShare === 1 ? true : false;

                    state.dept = props.data.teIdx;
                    state.idx = props.data.idx;
                    state.fileUrl = props.data.file;
                } else {
                    state.name = "";
                    state.isShare = false;

                    state.dept = 0;
                    state.idx = 0;
                    state.fileUrl = "";
                }
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackFun = () => {
                emit("callback", state);
            };

            const validateCheck = (text: string): boolean => {
                if (!text) {
                    return true;
                } else {
                    if (!CommonUtils.regexForPassword.test(text)) {
                        return true;
                    }
                }

                return false;
            };

            const handleFiles = (e: any) => {
                const file = e.target.files[0];

                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }

                let imgUrls = null;

                const reader = new FileReader();
                reader.onload = (ee: any) => {
                    imgUrls = ee.target.result;
                    state.fileUrl = imgUrls;
                    state.file = file;
                    file.value = "";
                };
                reader.readAsDataURL(file);
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            return { state, closeModal, callbackFun, validateCheck, handleFiles, downloadFile, deptList };
        },
    };
</script>

<style scoped>
    .content_wrap {
        margin-top: 20px;
    }
    .content_wrap ul li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
    }
    .content_wrap ul li > span {
        min-width: 80px;
        margin-right: 20px;
        text-align: right;
    }

    .content_wrap ul li > input {
        display: block;
        width: 100%;
        border: 0;
        background-color: #F7F7F9;
        font-family: Noto Sans KR;
        font-weight: 400;
        font-size: 16px;

        line-height: 100%;
        text-align: left;
        height: 30px;
    }

    .content_wrap .file_wrap label {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        align-items: stretch;

        font-family: Noto Sans KR;
        font-weight: 400;
        font-size: 16px;

        line-height: 100%;
        text-align: left;
    }

    .content_wraprap input[type="file"] {
        display: none;
    }

    .content_wrap .file_box_wrap {
        flex: calc(100% - 150px);
        border: 0;
        border-radius: 5px;
        padding: 0 10px;
        color: #6d6d6d;
        font-weight: 500;
    }

    .content_wrap .file_wrap .form_li_tit {
        min-width: 110px;
        letter-spacing: -0.5px;
        font-weight: 500;
        display: inline-block;
        color: #000;
    }

    .content_wrap .file_wrap .blue_btn {
        width: 140px;
        margin-left: 7px;
        height: auto;
    }

    .content_wrap .file_list {
        padding-left: 0;
        display: flex;
        gap: 15px;
        margin-top: 7px;
        flex-wrap: wrap;
    }

    .content_wrap .file .file_name {
        text-decoration: underline;
        color: #434343;
        transition: 0.2s;
    }

    .content_wrap .file .file_del {
        width: 18px;
        height: 18px;
        vertical-align: middle;
        display: inline-block;
        margin-left: 1px;
        margin-top: -3px;
        transition: 0.2s;
    }

    .content_wrap .file .file_del:hover {
        filter: brightness(1.15);
        transition: 0.2s;
    }

    .file_img {
    }
</style>
